import * as React from 'react'
import { useGoogleLogin, GoogleOAuthProvider, CredentialResponse, TokenResponse } from '@react-oauth/google'

interface GoogleSigninButtonProps {
	clientId?: string
	googleLogin: (response: CredentialResponse | TokenResponse) => void
	onError: (error: boolean) => void
}

const CustomGoogleSigninButton: React.FunctionComponent<GoogleSigninButtonProps> = (props) => {
	return props.clientId ? (
		<GoogleOAuthProvider clientId={props.clientId}>
			<LoginButton {...props} />
		</GoogleOAuthProvider>
	) : (
		<></>
	)
}

const LoginButton: React.FunctionComponent<GoogleSigninButtonProps> = (props) => {
	const login = useGoogleLogin({
		onSuccess: (response: TokenResponse) => {
			props.googleLogin(response)
		},
		onError: () => {
			props.onError(true)
		},
	})
	return (
		<div
			className="btn btn__secondary btn--google"
			onClick={() => {
				login()
			}}
		>
			Sign up with Google
		</div>
	)
}

export default CustomGoogleSigninButton
